import { RouteComponentProps } from "react-router-dom";
import Tokens from "./Tokens";
import { NonAuthRoutes } from "../shared/enums";
import { Route, Redirect } from "react-router-dom";

interface IAuthProps {
  Component: React.FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
}

export const AuthRoute = ({
  Component,
  path,
  exact = false,
}: IAuthProps): JSX.Element => {
  const tokens = Tokens.getInstance();
  const isAuthorized = tokens.getToken();

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) =>
        isAuthorized ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: NonAuthRoutes.login,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};
